import { defineStore } from 'pinia';
import api from '@/services/api';

export const useRolStore = defineStore('rolStore', {
  state: () => ({
    rolList: [],
    page: 1,
    rolSelected: null,
    loading: false,
    error: null,
  }),
  actions: {
    async findAllRolHTTP(params = {}) {
      try {
        this.loading = true;
        this.error = null;
        const page = params.page ?? this.page;
        const result = await api.get('/rol', { params: { page, ...params } });

        if (result?.data) {
          this.rolList.splice(0, this.rolList.length, ...result.data);
          this.setPage(page + 1);
          return true;
        }
        return false;
      } catch (err) {
        this.setError(err);
        throw err;
      } finally {
        this.loading = false;
      }
    },
    async findRolByCodigoHTTP(codigo) {
      try {
        this.loading = true;
        this.error = null;

        const res = await api.get(`/rol/${codigo}`);
        this.rolSelected = res?.data ?? null;
        return this.rolSelected;
      } catch (err) {
        this.setError(err);
        throw err;
      } finally {
        this.loading = false;
      }
    },

    async createRolHTTP(payload) {
      try {
        this.loading = true;
        this.error = null;

        const res = await api.post('/rol', payload);
        await this.firstRol();
        return res?.data;
      } catch (err) {
        this.setError(err);
        throw err;
      } finally {
        this.loading = false;
      }
    },

    async updateRolHTTP(codigo, payload) {
      try {
        this.loading = true;
        this.error = null;

        const res = await api.patch(`/rol/${codigo}`, payload);
        await this.firstRol();
        return res?.data;
      } catch (err) {
        this.setError(err);
        throw err;
      } finally {
        this.loading = false;
      }
    },
    async deleteRolHTTP(codigo) {
      try {
        this.loading = true;
        this.error = null;

        const res = await api.delete(`/rol/${codigo}`);
        await this.firstRol();
        return res?.data;
      } catch (err) {
        this.setError(err);
        throw err;
      } finally {
        this.loading = false;
      }
    },
    async firstRol() {
      this.setPage(1);
      this.emptyList();
      await this.findAllRolHTTP({ page: 1 });
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.rolList = [];
    },
    setError(err) {
      this.error = err;
    },
  },
});
